<template>
    <!--Project Blk-->
    <div class="project-block" v-loading="loading">
        <div class="project-img">
            <div class="project-img-inner" :class="{ 'has-thumbnail': fundraiser.fundraiser_image_uri }">
                <a :href="fundraiser.fundraiser_uri">
                    <img :src="getImageUrl" alt="Project Image">
                </a>
            </div>
            <div class="pro-check" v-if="fundraiser.fundraiser_goal !== fundraiser.fundraiser_raised_amount">
                <a href="#" @click.prevent="toggleCheckout" :class="favoriteClass" v-show="!cartIsFull || inCart"></a>
            </div>
        </div>
        <div class="project-content eq-height">
            <a :href="fundraiser.fundraiser_uri">
                <div class="project-content-inner">
                    <h5 class="title-5">{{fundraiser.name}}</h5>
                    <strong>{{fundraiser.grade_taught}}</strong>
                    <p class="paragraph">{{excerpt}}</p>
                    <h6 class="title-6">{{fundraiser.school}}</h6>
                    <span>{{fundraiser.district}}</span>
                    <ul>
                        <li>{{fundraiser.city}}</li>
                        <li>{{fundraiser.state}}</li>
                        <li>{{fundraiser.zip}}</li>
                    </ul>
                    <p class="percentage">{{fundraiser.account_school_farl_percentage}}% National School Lunch Program</p>
                </div>
                <div class="progress-bar-blk">
                    <div class="progress skill-bar">
                        <div class="progress-bar progress-bar-success" role="progressbar"
                             :style="'width: '+raisedPercentage+'%;'" :aria-valuenow="raisedPercentage"
                             aria-valuemin="90" aria-valuemax="90">
                        </div>
                    </div>
                    <div class="progress-title">
                        <p>{{numberToCurrency(fundraiser.fundraiser_raised_amount)}} raised <span>of {{numberToCurrency(fundraiser.fundraiser_goal)}}</span>
                        </p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    currentCart: {
      required: false
    }
  },
  watch: {
    currentCart: {
      deep: true,
      handler (newVal) {
        this.cartId = newVal.id
      }
    }
  },
  computed: {
    raisedPercentage () {
      return (this.fundraiser.fundraiser_raised_amount * 100) / this.fundraiser.fundraiser_goal
    },
    getImageUrl () {
      if (this.fundraiser.fundraiser_image_uri === null || this.fundraiser.fundraiser_image_uri === undefined) {
        const index = Math.floor((Math.random() * 4) + 1)
        return '/images/content/thumbnail.png'
      }

      return this.fundraiser.fundraiser_image_uri
    },
    excerpt () {
      const tokens = this.fundraiser.personal_statement.split(' ')
      return tokens.slice(0, 17).join(' ') + '...'
    },
    favoriteClass () {
      return this.inCart ? 'fav-excerpt-check clicked' : 'fav-excerpt-check'
    },
    addItemRoute () {
      if (this.cartId !== null) {
        return window.App.globalData.routes.add_item_to_cart.replace('ID', this.cartId)
      }
      return window.App.globalData.routes.create_cart
    },
    removeItemRoute () {
      return window.App.globalData.routes.remove_item_from_cart.replace('ID', this.cartId)
    },
    item () {
      return {
        name: this.fundraiser.name,
        grade: this.fundraiser.grade_taught,
        state: this.fundraiser.state_name,
        school: this.fundraiser.school,
        district: this.fundraiser.district,
        goal_amount: (App.goal_amount / 100),
        fundraiser_id: this.fundraiser.fundraiser_id,
        raised_amount: this.fundraiser.fundraiser_raised_amount,
        new_teacher_id: null,
        fundraiser_slug: this.fundraiser.fundraiser_slug,
        current_donation: this.getMinAmount()
      }
    }

  },
  data () {
    return {
      inCart: false,
      loading: false,
      cartId: null,
      cartIsFull: false
    }
  },
  methods: {
    numberToCurrency (number) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
        // the default value for minimumFractionDigits depends on the currency
        // and is usually already 2
      })

      return formatter.format(number).replace('$', '$ ')
    },
    toggleCheckout () {
      if (this.inCart) {
        this.removeFromCart()
        return
      }
      if (this.currentCart === null) {
        this.createCart()
        return
      }
      this.addToCart()
    },
    createCart () {
      const createRoute = window.App.globalData.routes.create_cart
      axios.post(createRoute).then(response => {
        this.cartId = response.data.data.cart_id
        kinfEvents.$emit('CartCreated', this.cartId)
        window.localStorage.setItem('cartId', this.cartId)
        this.addToCart()
      }).catch(e => {
        console.log(e.response)
        this.loading = false
        this.$notify({
          title: 'Error',
          message: e.response.data.response.message,
          type: 'error'
        })
      })
    },
    addToCart () {
      this.loading = true
      const amount = this.getMinAmount()
      axios.post(this.addItemRoute, {
        amount: amount,
        fundraiser_id: this.fundraiser.fundraiser_id,
        item: this.item
      }).then(response => {
        // console.log(response);
        this.loading = false
        this.inCart = true
        this.cartId = response.data.data.cart_id
        kinfEvents.$emit('newCartItem', response.data.data.item)
        window.localStorage.setItem('cartId', this.cartId)
        this.cartIsFull = this.currentCart == null ? false : Object.keys(this.currentCart.items).length === 18
        this.$notify({
          title: 'Success',
          message: response.data.response.message,
          type: 'success'
        })
      }).catch(e => {
        this.loading = false
        if (e.response !== undefined) {
          console.log(e.response)
          this.$notify({
            title: 'Error',
            message: e.response.data.response.message,
            type: 'error'
          })
        }
      })
    },
    removeFromCart () {
      this.loading = true
      axios.patch(this.removeItemRoute, {
        fundraiser_id: this.fundraiser.fundraiser_id
      }).then(response => {
        console.log(response)
        this.loading = false
        this.inCart = false
        this.$notify({
          title: 'Success',
          message: response.data.response.message,
          type: 'success'
        })
        this.cartIsFull = this.currentCart == null ? false : Object.keys(this.currentCart.items).length === 18
        kinfEvents.$emit('cartItemRemoved', this.fundraiser.fundraiser_slug)
      }).catch(e => {
        this.loading = false
        if (e.response !== undefined) {
          console.log(e.response)
          this.$notify({
            title: 'Error',
            message: e.response.data.response.message,
            type: 'error'
          })
        }
      })
    },
    verifyIfInCart () {
      if (Object.keys(this.currentCart.items).length === 0) {
        return false
      }
      return this.currentCart.items[this.fundraiser.fundraiser_slug] !== undefined
    },
    getMinAmount () {
      let minAmount = 0
      const moneyToComplete = this.fundraiser.fundraiser_goal - this.fundraiser.fundraiser_raised_amount
      const amounts = [moneyToComplete, 25, 50, 100]
      amounts.filter((value) => {
        // console.log(value,moneyToComplete);
        if (value <= moneyToComplete) {
          minAmount = value
        }
      })
      minAmount = minAmount < 1 ? 1 : minAmount
      return minAmount
    }
  },
  mounted () {
    this.cartIsFull = this.currentCart == null ? false : Object.keys(this.currentCart.items).length === 18

    const vm = this
    jQuery('.project-img-inner').imgLiquid()
    jQuery(window).bind('debouncedresize', function () {
      jQuery('.project-img-inner')
        .imgLiquid()
    })

    // here method to verify if this fundraiser has a current donation;
    if (this.currentCart !== null) {
      this.cartId = this.currentCart.id
      this.inCart = this.verifyIfInCart()
    }

    kinfEvents.$on('updateHearts', ev => {
      vm.$forceUpdate()
      this.cartIsFull = this.currentCart == null ? false : Object.keys(this.currentCart.items).length === 18
      vm.inCart = this.verifyIfInCart()
    })

    kinfEvents.$on('cartItemRemoved', ev => {
      this.cartIsFull = this.currentCart == null ? false : Object.keys(this.currentCart.items).length === 18
    })

    kinfEvents.$on('newCartItem', ev => {
      this.cartIsFull = this.currentCart == null ? false : Object.keys(this.currentCart.items).length === 18
    })
  }
}
</script>

<style>
.project-img-inner {
    background-color: #efefef;
    background-size: contain !important;
}
.has-thumbnail {
    background-size: cover !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/index/FundraiserProject.vue